/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ nodeName: NonNullable<unknown>, lpName: NonNullable<unknown> }} Coinvestments_Dataroom_Lpaccess3Inputs */

const en_coinvestments_dataroom_lpaccess3 = /** @type {(inputs: Coinvestments_Dataroom_Lpaccess3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.nodeName} access for ${i?.lpName}`)
};

/**
* | output |
* | --- |
* | "{nodeName} access for {lpName}" |
*
* @param {Coinvestments_Dataroom_Lpaccess3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_dataroom_lpaccess3 = /** @type {((inputs: Coinvestments_Dataroom_Lpaccess3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Dataroom_Lpaccess3Inputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_dataroom_lpaccess3(inputs)
});
export { coinvestments_dataroom_lpaccess3 as "coInvestments_dataRoom_lpAccess" }